module.exports = __webpack_public_path__ + "img/history-date.c99d3afa.svg";